import { HTTP_STATUS } from "@/config/polling.config";
import { store } from "@/store";
import { setPollingError, setPollingSuccess } from "@/store/slices/ui/uiSlice";
import type { Meta } from "@/types/shared/polling.types";

/**
 * Imperative (non-React) API for dispatching polling modals
 */
export const dispatchPollingError = (title: string, message: string, meta?: Meta) => {
   store.dispatch(
    setPollingError({
      title,
      message,
      details: meta ?? null,
    })
  );
};

export const dispatchPollingSuccess = (
  title: string,
  message: string,
  resourceUrl?: string | null,
  meta?: Meta
) => {
   store.dispatch(
    setPollingSuccess({
      title,
      message,
      resourceUrl: resourceUrl ?? null,
    })
  );
};

/**
 * Utility helper to check for retryable status codes.
 */
export function isRetryableStatus(status: number): boolean {
  return (
    status === HTTP_STATUS.TOO_MANY_REQUESTS ||
    (status >= HTTP_STATUS.INTERNAL_SERVER_ERROR_MIN &&
      status <= HTTP_STATUS.INTERNAL_SERVER_ERROR_MAX)
  );
}
